import { Model } from '../general'

import { Address } from './address'

export interface Data {
  id: number
  company_id: number
  name?: string
  address: Address
  nr_of_buildings?: number
  nr_of_workspaces?: number
}

class Location extends Model<Data> {
  get companyId() {
    return this.data.company_id
  }

  get name() {
    return this.data.name
  }

  get displayName() {
    return `${this.name}, ${this.addressLine1}`
  }

  get displayAddress() {
    if (!this.addressLine1 || !this.zipCode || !this.city) return ''
    return `${this.addressLine1}, ${this.zipCode} ${this.city}`
  }

  get addressLine1() {
    return this.data.address?.address_line_1
  }

  get addressLine2() {
    return this.data.address?.address_line_2
  }

  get city() {
    return this.data.address?.city
  }

  get zipCode() {
    return this.data.address?.zipcode
  }

  get countryCode() {
    return this.data.address?.country_code
  }

  get timeZoneId() {
    return this.data.address?.time_zone
  }

  get searchText(): string {
    return `${this.name}`
  }

  get numberOfBuildings(): number {
    return this.data.nr_of_buildings || 0
  }

  get numberOfWorkspaces(): number {
    return this.data.nr_of_workspaces || 0
  }

  get latitude() {
    return this.data.address?.latitude
  }
  get longitude() {
    return this.data.address?.longitude
  }
}

export default Location
